import * as angular from 'angular';
import { AccountService } from '../../account/account.service';
import { IRetailerRootScope } from '../../core/models';

export interface IMenu {
    title: string;
    icon?: string;
    isOpen: boolean;
    urlBase?: string;
    relatedUrls?: string[];
    url: string;
    description?: string;
    submenu?: IMenu[];
    additionalClass?: string;
}
export interface IModeMenu {
    label: string;
    tooltip: string;
    isSimple: boolean;
    switch: () => void;
}

export class NavigationService {
    public static $inject = ['$rootScope', '$translate', 'accountService'];

    public menu: IMenu[];
    public mode: IModeMenu;
    public adminMenu: IMenu;

    private homeMenu: IMenu;
    private placesMenu: IMenu;
    private productsForNfrnMenu: IMenu;
    private productAndBundlessMenuItems: IMenu;
    private campaignsMenu: IMenu;
    private nfcMenu: IMenu;
    private informationCardsMenu: IMenu;
    private analyticsMenu: IMenu;
    private warningsMenu: IMenu;
    private retailerAdminMenuItems: IMenu;
    private managerAdminMenuItems: IMenu;
    private helpMenu: IMenu;
    private productImportHelpMenu: IMenu;
    private retailerStaffMenu: IMenu;
    private vouchersMenu: IMenu;
    private productsForPublisher: IMenu;
    private dppAnalytics: IMenu;
    private publisherSettings: IMenu;
    private bundlesMenu: IMenu;
    private printersMenu: IMenu;

    constructor(
        private $rootScope: IRetailerRootScope,
        private $translate: angular.translate.ITranslateService,
        private accountService: AccountService
    ) {
        this.homeMenu = {
            title: this.$translate.instant('menu_home'),
            isOpen: false,
            url: 'app.dashboard'
        };

        this.placesMenu = {
            title: this.$translate.instant('menu_places'),
            isOpen: false,
            urlBase: 'app.shop',
            relatedUrls: ['app.create-shop', 'app.inventory'],
            url: 'app.shops',
            description: this.$translate.instant('menu_places_description'),
            icon: 'icon-sidebar-location'
        };

        this.productsForNfrnMenu = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: 'app.products',
            icon: 'icon-sidebar-products',
        };

        /* Products and bundles submenus */
        const productsMenu: IMenu = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: 'app.products'
        };

        const bundlesMuenu: IMenu = {
            title: this.$translate.instant('menu_bundles'),
            isOpen: false,
            url: 'app.bundles'
        };

        const servicesMenu: IMenu = {
            title: this.$translate.instant('services_menu_item'),
            isOpen: false,
            url: 'app.activeServices',
            relatedUrls: [
                'app.activeServices',
                'app.archivedServices',
                'app.editService',
                'app.serviceCreate'
            ]
        };

        const menusMuenu: IMenu = {
            title: this.$translate.instant('menu_menus'),
            isOpen: false,
            url: 'app.menus',
            relatedUrls: [
                'app.create-menu',
                'app.edit-menu',
                'app.extras.archived'
            ]
        };

        const ingredientsMenu: IMenu = {
            title: this.$translate.instant('ingredients'),
            isOpen: false,
            url: 'app.activeIngredients',
            relatedUrls: [
                'app.activeIngredients',
                'app.archivedIngredients'

            ]
        };

        const extrasMenu: IMenu = {
            title: this.$translate.instant('menu_extras'),
            isOpen: false,
            url: 'app.extras.active',
            relatedUrls: [
                'app.extras.edit',
                'app.extras.new',
                'app.extras.archived'
            ]
        };

        this.productAndBundlessMenuItems = {
            title: this.$translate.instant('menu_products_and_bundles'),
            urlBase: 'app.productsAndBundles',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-products',
            submenu: [productsMenu, servicesMenu, menusMuenu, ingredientsMenu, extrasMenu]
        };
        /*  */

        this.nfcMenu = {
            title: this.$translate.instant('menu_nfc'),
            isOpen: false,
            urlBase: 'app.nfcs.active',
            relatedUrls: [
                'app.nfc.active',
                'app.nfc.deleted',
                'app.nfc.history',
                'app.nfc.export',
                'app.nfc.wizard'
            ],
            url: 'app.nfcs.active',
            icon: 'icon-sidebar-nfc'
        };

        this.informationCardsMenu = {
            title: this.$translate.instant('menu_information_cards'),
            isOpen: false,
            urlBase: 'app.information-card',
            relatedUrls: [
                'app.information-card.edit',
                'app.information-card.new'
            ],
            url: 'app.information-cards',
            icon: 'icon-sidebar-infotags'
        };

        const marketingCampaignsMenu = {
            title: this.$translate.instant('menu_marketing_campaigns'),
            isOpen: false,
            url: 'app.marketing-campaigns.overview'
        };

        const marketPlaceMenu = {
            title: this.$translate.instant('menu_marketplace'),
            isOpen: false,
            url: 'app.marketplace'
        };

        this.campaignsMenu = {
            title: this.$translate.instant('menu_campaigns'),
            urlBase: 'app.marketing-campaigns.overview',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-campaigns',
            submenu: [marketingCampaignsMenu, marketPlaceMenu]
        };

        this.analyticsMenu = {
            title: this.$translate.instant('menu_analytics'),
            isOpen: false,
            url: 'app.analytics',
            urlBase: 'app.analytics',
            icon: 'icon-sidebar-analytics'
        };

        this.warningsMenu = {
            title: this.$translate.instant('menu_warnings'),
            isOpen: false,
            url: 'app.warnings',
            urlBase: 'app.warnings',
            icon: 'icon-sidebar-warnings'
        };

        this.vouchersMenu = {
            title: this.$translate.instant('vouchers'),
            isOpen: false,
            urlBase: 'app.vouchers.list',
            url: 'app.vouchers.list',
            icon: 'icon-sidebar-vouchers'
        };

        this.bundlesMenu = {
            title: this.$translate.instant('bundles'),
            isOpen: false,
            urlBase: 'app.bundles',
            url: 'app.bundles',
            icon: 'icon-sidebar-bundles'
        };

        this.printersMenu = {
            title: this.$translate.instant('printers'),
            isOpen: false,
            urlBase: 'app.printers.list',
            url: 'app.printers.list',
            icon: 'icon-sidebar-printers'
        };

        // Admin menu items
        const jispPayPlacesMenuItem: IMenu = {
            title: this.$translate.instant('menu_admin_jispPay'),
            isOpen: false,
            url: 'app.jisppay.places'
        };
        const orderSettingsMenuItem: IMenu = {
            title: this.$translate.instant('menu_admin_orderSettings'),
            isOpen: false,
            url: 'app.orderSettings.locations'
        };
        const discountForStaffMenuItem: IMenu = {
            title: this.$translate.instant('menu_admin_discountForStaff'),
            isOpen: false,
            url: 'app.discountForStaffs',
            relatedUrls: [
                'app.discountForStaffs.special.active',
                'app.discountForStaffs.special.archived',
                'app.discountForStaffs.transaction.withDiscount',
                'app.discountForStaffs.transaction.export',
                'app.discountForStaffs.transaction.singleTransaction'
            ]
        };
        const clickAndDeliverMenuItem: IMenu = {
            title: this.$translate.instant('menu_click_and_deliver'),
            isOpen: false,
            url: 'app.clickAndDeliver'
        };
        const loyaltyMenuItem: IMenu = {
            title: this.$translate.instant('menu_admin_loyalty_program'),
            isOpen: false,
            url: 'app.loyalty.program'
        };
        const referralAccountsMenuItem: IMenu = {
            title: this.$translate.instant('menu_admin_referral_accounts'),
            isOpen: false,
            url: 'app.referral-accounts'
        };
        this.retailerStaffMenu = {
            title: this.$translate.instant('menu_admin_staff_accounts'),
            isOpen: false,
            url: 'app.jisppay.staff',
            icon: 'icon-sidebar-admin'
        };
        const adminManagerMenuItem = {
            title: this.$translate.instant('menu_admin_manager_accounts'),
            isOpen: false,
            url: 'app.managers.accounts'
        };

        this.retailerAdminMenuItems = {
            title: 'Admin',
            urlBase: 'app.admin',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-admin',
            submenu: [
                jispPayPlacesMenuItem,
                orderSettingsMenuItem,
                discountForStaffMenuItem,
                clickAndDeliverMenuItem,
                referralAccountsMenuItem,
                this.retailerStaffMenu,
                adminManagerMenuItem
            ]
        };
        this.managerAdminMenuItems = {
            title: 'Admin',
            urlBase: 'app.admin',
            isOpen: false,
            url: null,
            icon: 'icon-sidebar-admin',
            submenu: [
                jispPayPlacesMenuItem,
                orderSettingsMenuItem,
                discountForStaffMenuItem,
                clickAndDeliverMenuItem,
                referralAccountsMenuItem,
                this.retailerStaffMenu
            ]
        };

        this.helpMenu = {
            title: this.$translate.instant('menu_help'),
            additionalClass: 'menu-help',
            isOpen: false,
            url: null,
            icon: null
        };

        const importFormatMenuItem: IMenu = {
            title: this.$translate.instant('menu_file_format_and_properties'),
            isOpen: false,
            url: 'app.help.manual',
            additionalClass: 'pl35'
        };

        const categoryMenuItem: IMenu = {
            title: this.$translate.instant('menu_categories_and_item_types'),
            isOpen: false,
            url: 'app.help.dictionary',
            additionalClass: 'pl35'
        };

        const countriesMenuItem: IMenu = {
            title: this.$translate.instant('menu_countries'),
            isOpen: false,
            url: 'app.help.countries',
            additionalClass: 'pl35'
        };

        const preferenceMenuItem: IMenu = {
            title: this.$translate.instant(
                'menu_food_preferences_and_allergens'
            ),
            isOpen: false,
            url: 'app.help.preferences',
            additionalClass: 'pl35'
        };

        this.productImportHelpMenu = {
            title: this.$translate.instant('menu_product_import'),
            urlBase: 'app.help.manual',
            isOpen: false,
            url: null,
            icon: null,
            submenu: [
                importFormatMenuItem,
                categoryMenuItem,
                countriesMenuItem,
                preferenceMenuItem
            ]
        };

        this.productsForPublisher = {
            title: this.$translate.instant('menu_products'),
            isOpen: false,
            url: null,
            urlBase: 'app.products',
            icon: 'icon-sidebar-products',
            submenu: [productsMenu],
        };

        const downloads: IMenu = {
            title: this.$translate.instant('downloads'),
            isOpen: false,
            url: 'app.downloads'
        };

        this.dppAnalytics = {
            title: this.$translate.instant('menu_analytics'),
            isOpen: false,
            url: null,
            urlBase: 'app.downloads',
            icon: 'icon-sidebar-analytics',
            submenu: [downloads]
        };

        this.publisherSettings = {
            title: this.$translate.instant('publisher_settings'),
            isOpen: false,
            urlBase: 'app.publisherSettings',
            url: 'app.publisherSettings',
            icon: 'icon-sidebar-publisher-settings'
        };
    }

    public getMenu() {
        this.$rootScope.userData = this.accountService.userData;
        if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Retailer) {
            return [
                this.placesMenu,
                this.campaignsMenu,
                this.productAndBundlessMenuItems,
                this.bundlesMenu,
                this.vouchersMenu,
                this.nfcMenu,
                this.informationCardsMenu,
                this.printersMenu,
                this.analyticsMenu,
                this.warningsMenu,
                this.retailerAdminMenuItems
            ];
        } else if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Nfrn) {
            return [
                this.placesMenu,
                this.productsForNfrnMenu,
                this.retailerStaffMenu
            ];
        } else if (this.$rootScope.userData.permission === this.$rootScope.enums.RetailerPermission.Publisher) {
            return [
                this.productsForPublisher,
                this.dppAnalytics,
                this.publisherSettings
            ];
        } else {
            return [
                this.placesMenu,
                this.campaignsMenu,
                this.productAndBundlessMenuItems,
                this.informationCardsMenu,
                this.analyticsMenu,
                this.warningsMenu,
                this.managerAdminMenuItems
            ];
        }
    }

    public getAdminMenu() {
        if (
            this.$rootScope.userData.permission ===
            this.$rootScope.enums.RetailerPermission.Retailer
        ) {
            return this.retailerAdminMenuItems;
        } else {
            return this.managerAdminMenuItems;
        }
    }

    public getHelpMenu(isAnon: boolean = false) {
        this.$rootScope.userData = isAnon ? null : this.accountService.userData;
        return [this.helpMenu, this.productImportHelpMenu];
    }
}

angular.module('app.common').service('navigationService', NavigationService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/services/navigation.service.ts